export default __webpack_public_path__ + "static/media/Icon ionic-ios-warning.37bb7935.svg";